module.exports = __webpack_public_path__ + "img/active.b937b233.svg";